import { SkipButton, StopButton } from './Buttons';
import { useSkipStepForCandidateMutation } from '@/store/query/mco-candidates';
import { useParams } from 'react-router-dom';
import { useShowToast } from '@/hooks/useShowToast';

const channelConstants = {
  email: { id: 'email', value: 'Email' },
  li_inmail: { id: 'li_inmail', value: 'Linkedin inmail' },
  li_connection: { id: 'li_connection', value: 'Connection request' },
};

const getSkipStepName = (skipToStep) => {
  const channelNamelength =
    (channelConstants?.[skipToStep?.channel]?.value?.length || 0) + 2;
  const stepNameLength = skipToStep?.name?.length || 0;
  if (stepNameLength + channelNamelength >= 33) {
    return `${skipToStep?.name?.substring(0, 30 - channelNamelength)}...`;
  }
  return skipToStep?.name;
};

export const ShowSkipStop = ({
  restartDetails = {},
  onStopOpen = () => {},
}) => {
  const params = useParams();
  const skipToStep =
    restartDetails?.outreach_candidate?.step_to_restart?.skips_to_step || {};
  const stepToRestart =
    restartDetails?.outreach_candidate?.step_to_restart || {};
  const skipStepName = getSkipStepName(skipToStep);

  const toast = useShowToast();
  const [skipCandidate, { isLoading }] = useSkipStepForCandidateMutation();

  const onSkip = async () => {
    try {
      const result = await skipCandidate({
        outreachId: params?.outreachId,
        candidates: [
          {
            candidate_id: restartDetails?.outreach_candidate?.candidate_id,
            step_id: stepToRestart?.id,
          },
        ],
      });

      if (result?.data?.[0]?.errors?.length) {
        toast({
          description: 'Unable to skip the step',
          position: 'bottom-left',
          status: 'error',
        });
        return;
      }
      toast({
        description: 'Candidate has been moved to next step',
        position: 'bottom-left',
        status: 'success',
      });
    } catch {}
  };

  return (
    <>
      {skipToStep?.id && (
        <SkipButton
          buttonText={`Skip to ${skipStepName || ''} (${
            channelConstants?.[skipToStep?.channel]?.value || ''
          })`}
          onSkip={onSkip}
          isLoading={isLoading}
          data-test-id="flow-restart-action-skip"
        />
      )}
      <StopButton
        onClick={onStopOpen}
        data-test-id="flow-restart-action-stop"
      />
    </>
  );
};
